<template>
  <v-dialog v-model="dialog"
            persistent
            max-width="500px"
            @keydown.esc="close"
  >
    <v-card>
      <div style="display:flex; justify-content: space-between; align-items: center; height: 60px;">
        <div class="popup-title">인터넷망 스마트회의</div>
      </div>
      <div class="dialog-body detailTable" style="margin-top: 0;">
        <table>
          <colgroup>
            <col style="width:100px" />
            <col style="width:200px" />
          </colgroup>
          <tbody>
            <!--<tr>
              <th>
                <span>인터넷망 비밀번호</span>
              </th>
              <td class="name">
                {{ prevPassword }}
              </td>
            </tr>
          -->
            <tr>
              <th>
                <span>비밀번호 초기화</span>
              </th>
              <td class="name">
                <input type="password" style="width: 70%;" v-model="newExPassword"/>
                <button @click="updateExPassword">적용</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="btnArea">
        <button class="btnPrimary" @click="closeDialog">닫기</button>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import Util from '@/util';

export default {
  components: {
  },
  props: [
    'dialog', 'closeDialog',
  ],
  data: () => ({
    prevPassword: null,
    newExPassword: null,
  }),
  watch: {
    dialog: {
      handler (val) {
        if (val) {
          this.init();
        }
      }
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    async init () {
      this.newExPassword = null;   
      let empNum = this.$store.state.user.empNum;
      await this.$http.post('/api/auth/userPassword', { empNum: empNum }).then((response) => {
        let rst = response.data.password;
        this.prevPassword = rst;
      }).catch(error => {
        console.log(error);
      });
    },
    async updateExPassword () {
      let newExPassword = this.newExPassword;
      await this.$http.post('/api/auth/updateNewExPassword', { empNum: this.$store.state.user.empNum, newExPassword: newExPassword }).then((response) => {
        if (response.data === 'success') {
          alert('인터넷망 비밀번호 변경완료');
          this.newExPassword = null;
          this.closeDialog();
        }
      }).catch(error => {
        console.log(error);
      });
    },

  }
};
</script>

<style>
#modifyProfileDialog td {
  border: none;
}
#modifyProfileDialog .profile-popup_top{
  position: relative;
  width: 100%;
  height: 135px;
  padding-top: 30px;
  padding-left: 20px;
  background: #1757a1;
  background-position: 80% 40%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-family: 'Noto Sans KR';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #fff;
  line-height: 2;
}

#modifyProfileDialog .dataTable table {
    width: 80%;
    margin-left: 10%;
}

#modifyProfileDialog table th {
  font-weight: normal;
  width: 40%;
}

#modifyProfileDialog .dataTable table td input {
  width: 200px;
  height: 46px;
  border: 2px solid #ecedef;
  border-radius: 5px;
  padding-left: 20px;
}

#modifyProfileDialog .dataTable table td select {
  width: 200px;
  height: 46px;
  border: 2px solid #ecedef;
  border-radius: 5px;
  padding-left: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/UpdateProfile.vue